export const EVENTS = {
    // =========================================================================
    // AUTH - Authentication & Session events
    // =========================================================================
    AUTH: {
        SIGNUP_ATTEMPT: 'SignUpAttempt',
        SIGNUP_CONFIRMED: 'SignUpAccountConfirmed',
        GOOGLE_LOGIN_FAILED: 'FailedGoogleLogin',
        EMBEDDED_CHAT: 'embed_token_initialized',
    },

    // =========================================================================
    // SESSION - Session tracking
    // =========================================================================
    SESSION: {
        TIMEOUT: 'sessionTimeout',
        CLOSE: 'sessionClose',
    },

    // =========================================================================
    // ONBOARDING - Onboarding flow events
    // =========================================================================
    ONBOARDING: {
        COMPLETE_ROLE: 'role',
        COMPLETE_GOALS: 'goals',
        COMPLETE_COMPANY: 'company',
        COMPLETE_PATH: 'pathSelection',
        DATA_UPLOAD: 'uploadData',
        DATA_UPLOAD_FAILED: 'onboardingDataUploadFailed',
    },

    // =========================================================================
    // WORKSPACE - Workspace events
    // =========================================================================
    WORKSPACE: {
        CREATE: 'newWorkspace',
        SWITCH: 'switchWorkspace',
    },

    // =========================================================================
    // CANVAS - Canvas events
    // =========================================================================
    CANVAS: {
        CREATE_BLANK: 'newCanvas',
        CREATE_FROM_PRESENTATION_ATTEMPT: 'attemptNewCanvasFromPresentation',
        CREATE_FROM_PRESENTATION_COMPLETE: 'completedNewCanvasFromPresentation',
        SEARCH_RECIPE: 'attemptSearchRecipe',
        CREATE_FROM_RECIPE_ATTEMPT: 'attemptNewCanvasFromRecipe',
        CREATE_FROM_RECIPE_COMPLETE: 'completeNewCanvasFromRecipe',
        CREATE_FROM_AI_ATTEMPT: 'attemptNewCanvasFromAI',
        DELETE: 'deleteCanvas',
        RENAME: 'renameCanvas',
        VIEW_PRESENTATION: 'viewTourInPresentationMode',
        ADD_ASSET: 'addCanvasAsset',
        SYNC_FROM_SLIDES: 'canvasSyncFromSlides',
        SYNC_TO_SLIDES: 'canvasSyncToSlides',
        RECIPE_PRODUCT_INVOCATION: 'attemptProductFromRecipe',
    },

    // =========================================================================
    // SCOOP_AI - Scoop AI / SocketChat events
    // =========================================================================
    SCOOP_AI: {
        SEND_MESSAGE: 'scoopAiSendMessage',
        OPEN_EXPLORER: 'scoopAiOpenExplorer',
        SAVE_SUMMARY: 'scoopAiSaveSummary',
        CLICK_FOLLOWUP: 'scoopAiClickFollowup',
        RESET_CONTEXT: 'scoopAiResetContext',
        SWITCH_QUICK_MODE: 'scoopAiSwitchQuickMode',
        SWITCH_EXTENDED_THINKING: 'scoopAiSwitchExtendedThinking',
    },

    // =========================================================================
    // DATA_SCIENCE - ML / Data Science events
    // =========================================================================
    DATA_SCIENCE: {
        FIND_SEGMENTS: 'dataScienceFindSegments',
        ID_COLUMN: 'dataScienceIdColumn',
        EXPLAIN_GROUP: 'dataScienceExplainGroup',
        PROCESS_ANALYSIS: 'aiMLInProduct',
    },

    // =========================================================================
    // EXPLORER - Explorer events
    // =========================================================================
    EXPLORER: {
        OPEN_SUMMARY: 'explorerOpenSummary',
        ASK_AI: 'explorerAskAi',
        SAVE_AS: 'explorerSaveAs',
    },

    // =========================================================================
    // DATASET - Dataset / Source events
    // =========================================================================
    DATASET: {
        UPLOAD_ATTEMPT: 'attemptUploadData',
        UPLOAD_COMPLETE: 'completeUploadData',
        CONNECT_INTEGRATION_ATTEMPT: 'attemptAPI',
        CONNECT_INTEGRATION_COMPLETE: 'completeAPI',
        CONNECT_INTEGRATION_UNAVAILABLE: 'newUnavailableConnectorFlow',
        CONNECT_DATABASE_COMPLETE: 'connectAPI',
        CONNECT_EMAIL_ATTEMPT: 'attemptNewEmailReportInbox',
        CONNECT_EMAIL_COMPLETE: 'completeNewEmailReportInbox',
        CONNECT_SLACK: 'connectSlack',
        CREATE_CALCULATED_COLUMN: 'createCalculatedColumn',
        EDIT_SEMANTICS: 'editSemantics',
        CONFIGURE_PROPERTIES: 'configureProperties',
        SETUP_WRITEBACK: 'setupWriteback',
        MODIFY_API_CONNECTION: 'modifyApiConnection',
    },

    // =========================================================================
    // LIVE_QUERY - Live Query events
    // =========================================================================
    LIVE_QUERY: {
        CREATE: 'newLiveQuery',
    },

    // =========================================================================
    // LIVE_WORKSHEET - Live Worksheet events
    // =========================================================================
    LIVE_WORKSHEET: {
        CREATE: 'newLiveWorksheet',
    },

    // =========================================================================
    // ACCOUNT - Account settings events
    // =========================================================================
    ACCOUNT: {
        ADD_AI_PROVIDER: 'addAiProvider',
        UPGRADE: 'upgradeAccount',
        CONTACT_SALES: 'contactSales',
        CONTACT_SUPPORT: 'contactSupport',
        INVITE_TEAM_MEMBER: 'inviteTeamMember',
        ADD_MEMBER_TO_WORKSPACE: 'addMemberToWorkspace',
    },

    // =========================================================================
    // HELPBOT - HelpBot events
    // =========================================================================
    HELPBOT: {
        OPEN: 'scoopHelpBotOpen',
        RESPONSE: 'scoopHelpBot',
    },

    // =========================================================================
    // CHAT_FEEDBACK - Query feedback events
    // =========================================================================
    CHAT_FEEDBACK: {
        POSITIVE: 'query_feedback_positive',
        NEGATIVE: 'query_feedback_negative',
        CORRECTION: 'query_feedback_correction',
    },

    // =========================================================================
    // ERROR - Error tracking events
    // =========================================================================
    ERROR: {
        OOPS: 'oopsError',
    },
}
